






































import { Component, Watch, Mixins, Prop } from "vue-property-decorator";

import DatePickerInput from "@share/common/form/form-controls/date/date-picker/DatePickerInput.vue";
import TimeInput from "@share/common/form/form-controls/date/time-input/TimeInput.vue";
import DurationInput from "@share/common/form/form-controls/date/duration-input/DurationInput.vue";
import { DateTime, Interval } from "luxon";
import { validationMixin } from "vuelidate";
import { required, integer, maxValue, minValue } from "vuelidate/lib/validators";

import { isTimeString, isDateTime } from "@common/validation/date";
import { dateInOriginalOffset } from "@common/dateTimeHelper";

const validations = {
    date: {
        required,
        isDateTime
    },
    time: {
        required,
        isTimeString
    },
    duration: {
        required,
        integer,
        maxValue: maxValue(9999999),
        minValue: minValue(1)
    }
}

@Component({ components: { DatePickerInput, TimeInput, DurationInput }, validations })

export default class DateTimeControl extends Mixins(validationMixin) {
    @Prop() beginAt?: DateTime | null | string;
    @Prop() endAt?: DateTime | null;
    @Prop() offset: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: "" }) pastDateText: string;

    date = ""
    time = ""
    duration = ""

    created() {
        //necessary for init values after mount when props not setted yet
        const unwatchDateProp = this.$watch('beginAt', () => {
            this.watchOffset(this.offset);
            unwatchDateProp();
        });
    }

    mounted() {
        this.watchOffset(this.offset);
    }

    get endTime() {

        let endAt = this.endAt;

        if(typeof endAt === "string") {
            endAt = DateTime.fromISO(endAt)
        }

        return endAt?.toFormat(this.$t('common.dateTimeFormat').toString() + " T") ?? ""
    }

    validate() {
        this.$v.$touch();
    }

    @Watch('offset')
    watchOffset(offset: string) {
        if(this.beginAt && this.endAt) {

            let beginAt = this.beginAt;
            let endAt = this.endAt;

            if(typeof beginAt === "string") {
                beginAt = DateTime.fromISO(beginAt)
            }

            if(typeof endAt === "string") {
                endAt = DateTime.fromISO(endAt)
            }

            beginAt = dateInOriginalOffset(beginAt, parseInt(offset), false);
            endAt = dateInOriginalOffset(endAt, parseInt(offset), false);

            this.setValue(beginAt, endAt);
        }
    }

    setValue(beginAt?: DateTime | string | null, endAt?: DateTime | string | null) {

        if(typeof beginAt === "string") {
            beginAt = DateTime.fromISO(beginAt)
        }

        if(typeof endAt === "string") {
            endAt = DateTime.fromISO(endAt)
        }

        this.date = beginAt?.toISO() || "";
        this.time = beginAt?.toFormat("HH:mm") || "";

        if(beginAt && endAt) {
            const interval = Interval.fromDateTimes(beginAt, endAt)
            const duration = interval.toDuration("minutes");
            this.duration = duration.get("minutes").toString();
        }
        else {
            this.duration = ""
        }
    }

    @Watch('time')
    @Watch('date')
    @Watch('duration')
    getdate() {
        const offset = parseInt(this.offset)
        const date = dateInOriginalOffset(DateTime.fromISO(this.date), offset).startOf("day");

        if(!this.time) {
            this.$emit("updateBegin", date)
            return
        }

        const time = dateInOriginalOffset(DateTime.fromFormat(this.time, "HH:mm"), offset, false, true);
        const beginWithTime = date.plus({ hours: time?.hour || 0, minutes: time?.minute || 0 }); //

        if(beginWithTime.isValid) {
            this.$emit("updateBegin", beginWithTime)
        }

        const durationInt = parseInt(this.duration);

        if(durationInt && !isNaN(durationInt)) {
            const endDate = dateInOriginalOffset(beginWithTime.plus({ minutes: durationInt  }), offset)
            this.$emit("updateEnd", endDate)
        }
    }

    get beginAtIsPast() {
        return this.beginAt && (this.beginAt <= DateTime.local()) && this.time
    }

    get lang() {
        return this.$store.state.session?.language ?? 'en'
    }
}

